import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { UserAuthenticationEndPoint } from "../../api-routes";

const getALlUserList = async ({ page = 1, limit = 5, search = "" }) => {
  const paramsString = `?page=${page}&limit=${limit}&search=${search}`;
  return (
    await axiosInstance.get(
      UserAuthenticationEndPoint.GET_ALL_USERS + paramsString
    )
  ).data;
};
const getMe = async () => {
  return (await axiosInstance.get(UserAuthenticationEndPoint.ME)).data;
};

export const useAllUserList = ({ page, limit, status, search }) => {
  return useQuery({
    queryKey: ["all-users", { page, limit, status, search }],
    queryFn: () => getALlUserList({ page, limit, status, search }),
    keepPreviousData: true,
  });
};

export const useMe = () => {
  return useQuery({
    queryKey: ["me"],
    queryFn: getMe,
    keepPreviousData: true,
  });
};


const getUserById = async (id) => {
  if (!id) return null;
  return (await axiosInstance.get(`${UserAuthenticationEndPoint.GET_ALL_USERS}/${id}`)).data;
};

export const useUserById = (id) => {
  return useQuery({
    queryKey: ["recruiter", id],
    queryFn: () => getUserById(id),
    enabled: !!id,
  });
};

const editUserInformation = async ({ id, ...data }) => {
  const response = await axiosInstance.put(
    `${UserAuthenticationEndPoint.EDIT_USER}/${id}`,
    data
  );
  return response.data;
};

export const useEditUserInformation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: editUserInformation,
  });
};
const deleteRecruiterById = async (id) => {
  const response = await axiosInstance.delete(
    `${UserAuthenticationEndPoint.DELETE_RECRUITER}/${id}`
  );
  return response.data;
};

export const useDeleteRecruiterById = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteRecruiterById,
    onSuccess: (data) => {
      queryClient.invalidateQueries(["all-users"]);
    },
    onError: (error) => {
      console.error("Error deleting recruiter:", error);
    },
  });
};

const firstLoginStatus = async (data) => {
  return (
    await axiosInstance.post(UserAuthenticationEndPoint.DISABLE_FIRST_LOGIN)
  ).data;
};

export const useFirstLoginStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: firstLoginStatus,
    onSuccess: (data) => {
      queryClient.invalidateQueries(["user"]);
      console.log("First login status updated successfully");
    },
    onError: (error) => {
      console.error("Error updating first login status:", error);
    },
  });
};

const changePassword = async (passwordData) => {
  const response = await axiosInstance.patch(
    UserAuthenticationEndPoint.CHANGE_PASSWORD,
    passwordData
  );
  return response.data;
};

export const useChangePassword = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: changePassword,
    onSuccess: (data) => {
      if (data.token) {
        localStorage.setItem("token", data.token);
      }
      queryClient.invalidateQueries(["me"]);
      return data;
    },
    onError: (error) => {
      console.error("Error changing password:", error);
      throw error;
    },
  });
};

const forgotPassword = async (email) =>{
  const response = await axiosInstance.post(
    UserAuthenticationEndPoint.FORGOT_PASSWORD,
    {
      email
    }
  );
  return response.data;
};

export const useForgotPassword = () => {
  return useMutation({
    mutationFn: forgotPassword,
    onError: (error) => {
      console.error("Error sending password reset email:", error);
      throw error;
    },
  });
};

const resetPassword = async ({ token, password, passwordConfirm }) => {
  const response = await axiosInstance.patch(
    `${UserAuthenticationEndPoint.RESET_PASSWORD}/${token}`,
    { password, passwordConfirm }
  );
  return response.data;
};

export const useResetPassword = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: resetPassword,
    onSuccess: (data) => {
      queryClient.invalidateQueries(["me"]);
      return data;
    },
    onError: (error) => {
      console.error("Error resetting password:", error);
      throw error;
    },
  });
};

